export const SPECS = {
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems'
};
//# sourceMappingURL=SPECS.js.map